import * as React from "react";
import { DefaultButton, IconButton } from "office-ui-fabric-react";

export interface CustomPaginationProps {
  totalCount: number;
  search: any;
  name: string;
  getFrom: Function;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  totalCount,
  search,
  name,
  getFrom,
}) => {
  const pages = [];
  const maxPage = Math.ceil(totalCount / search.limit);
  const startIndex = search.offset / search.limit;
  const selectedIndex = startIndex + 1;
  const startIndexArr = [
    selectedIndex - 3,
    selectedIndex - 2,
    selectedIndex - 1,
    selectedIndex,
    selectedIndex + 1,
    selectedIndex + 2,
    selectedIndex + 3,
  ];
  let i = 1;
  // while (i <= maxPage) {
  //   pages.push(i);
  //   i++;
  // }
  while (i <= maxPage) {
    if (i === 1) {
      pages.push(i);
    }
    if (startIndexArr.includes(i)) {
      if (!pages.includes(i)) {
        pages.push(i);
      }
    } else {
      if (pages[pages.length - 1] !== "...") {
        pages.push("...");
      }
    }
    if (i === maxPage && !pages.includes(maxPage)) {
      pages.push(maxPage);
    }
    i++;
  }
  console.log("pagesArr", pages);

  return (
    <div className="pagination ">
      <span>{`Showing ${totalCount === 0 ? 0 : search.offset + 1}-${
        search.offset + search.limit <= totalCount
          ? search.offset + search.limit
          : totalCount
      } of ${totalCount} ${name}`}</span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      {pages
        // .splice(startIndex === 0 ? 0 : startIndex - 1, 3)
        .map((d: any, index) => {
          if (d === "...") {
            return <span className="pagination-more-btn">...</span>;
          } else {
            return (
              <IconButton
                key={index}
                className={`pagination-btn ${
                  startIndex + 1 === d ? "pagination-btn-active" : ""
                }`}
                onClick={() => {
                  getFrom((d - 1) * search.limit);
                }}
              >
                {d}
              </IconButton>
            );
          }
        })}
    </div>
  );
};

export default CustomPagination;
